import { render, staticRenderFns } from "./TenderItemTabs.vue?vue&type=template&id=ef8b5dc2&scoped=true"
import script from "./TenderItemTabs.vue?vue&type=script&lang=js"
export * from "./TenderItemTabs.vue?vue&type=script&lang=js"
import style0 from "./TenderItemTabs.vue?vue&type=style&index=0&id=ef8b5dc2&prod&lang=scss&scoped=true"
import style1 from "./TenderItemTabs.vue?vue&type=style&index=1&id=ef8b5dc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8b5dc2",
  null
  
)

export default component.exports